import {Severity} from '@mojility/coach-core';

const Login = function ($scope, $location, localize, eventsService, loginInteractor) {
  const $ctrl = this;

  $ctrl.$onInit = function () {
    $ctrl.localize = localize;
    $ctrl.username = '';
    $ctrl.password = '';
    $ctrl.eula = false;
    $ctrl.isShowingEula = false;
  };

  $ctrl.isLogInDisabled = function () {
    return($ctrl.username === '' || $ctrl.password === '')
  };

  $ctrl.submit = function () {
    return loginInteractor.login($ctrl.username.toLowerCase(), $ctrl.password, $ctrl.eula)
        .then(() => {
          $scope.$applyAsync(() => {
            $location.path('/dashboard');
          });
        }, error => {
          if (error.severity === Severity.OK) {
            $scope.$applyAsync(() => {
              $ctrl.isShowingEula = true;
            });
            eventsService.publishSystemMessage("Please accept the End User License Agreement.");
          } else if (error.severity === Severity.ERROR)
            eventsService.publishSystemError(error.message);
          else
            eventsService.publishSystemMessage(error.message);
        });
  };

  $ctrl.accept_eula = function() {
    $ctrl.eula = true;
    return $ctrl.submit();
  }
};

export default {
  name: 'login',
  obj: {
    controller: Login,
    templateUrl: 'components/login.html'
  },
  deps: []
};
